
import packageInfo from '../../package.json';
import { EnvName } from '@enums/environment.enum';

const scheme = 'https://';
const host = 'api.qevalpro.ai';
const authUrl: string = `${scheme}${host}`;
const clientUrl: string = `${scheme}${host}`;
const programUrl: string = `${scheme}${host}:`;
const locationUrl: string = `${scheme}${host}`;
const parentUrl: string = `${scheme}${host}`;
const filterUrl: string = `${scheme}${host}`;
const dispositionUrl: string =`${scheme}${host}`;
const userUrl: string = `${scheme}${host}`;
const assetUrl: string = `${scheme}${host}`;
const roleUrl: string = `${scheme}${host}`;

export const environment = {
  production: true,
  version: packageInfo.version,
  appName: 'forge',
  envName: EnvName.LOCAL,
  defaultLanguage: 'en',
  apiBaseUrl: authUrl,
  clientEndpoint: clientUrl,
  locationEndpoint: locationUrl,
  dispositionEndpoint:dispositionUrl,
  parentEndpoint: parentUrl,
  programEndpoint: programUrl,
  filterEndpoint: filterUrl,
  userEndpoint: userUrl,
  assetsEndpoint: assetUrl,
  roleEndpoint: roleUrl,
};
